import React from "react";

// Faint silhouette guides so patients frame each shot correctly.
const common = {
  fill: "none",
  stroke: "#4A5D52",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const Front = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <g {...common}>
      <path d="M50 14 C32 14 26 30 26 46 C26 64 34 84 50 92 C66 84 74 64 74 46 C74 30 68 14 50 14 Z" />
      <line x1="50" y1="20" x2="50" y2="70" strokeDasharray="3 4" />
      <line x1="30" y1="46" x2="70" y2="46" strokeDasharray="3 4" />
      <path d="M36 44 q5 -5 10 0" />
      <path d="M54 44 q5 -5 10 0" />
      <path d="M44 62 q6 5 12 0" />
    </g>
  </svg>
);

const Profile = ({ flip }) => (
  <svg viewBox="0 0 100 120" className="w-full h-full" style={flip ? { transform: "scaleX(-1)" } : {}}>
    <g {...common}>
      <path d="M64 16 C44 16 34 30 34 48 C34 56 30 60 27 66 C25 70 30 72 33 73 C34 82 40 92 54 94 C66 96 72 90 74 82" />
      <path d="M34 52 q-6 4 -3 9" />
      <path d="M30 74 q4 3 9 2" />
    </g>
  </svg>
);

const Body = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <g {...common}>
      <circle cx="50" cy="24" r="12" />
      <path d="M32 58 C32 44 40 40 50 40 C60 40 68 44 68 58 L66 96 L34 96 Z" />
      <line x1="42" y1="42" x2="42" y2="94" strokeDasharray="3 4" />
      <line x1="58" y1="42" x2="58" y2="94" strokeDasharray="3 4" />
    </g>
  </svg>
);

export const AngleGuide = ({ angle }) => {
  const map = {
    front: <Front />,
    left: <Profile />,
    right: <Profile flip />,
    extra: <Body />,
  };
  return (
    <div className="absolute inset-0 flex items-center justify-center opacity-[0.12] pointer-events-none p-4">
      <div className="w-20 h-24">{map[angle] || <Front />}</div>
    </div>
  );
};
